import { Observable } from 'rxjs';

export class ModalService {
    private modals: any[] = [];

    constructor() {
    }

    add(modal: any) {
        this.modals.push(modal);
    }

    remove(id: string) {
        this.modals = this.modals.filter(x => x.id !== id);
    }

    open(id: string, data: any) {
        const modal: any = this.modals.find(x => x.id === id);
        if (modal) {
            modal.open(data);
        }
    }

    close(id: string) {
        const modal: any = this.modals.find(x => x.id === id);
        modal.close();
    }

    confirm(message?: string): Observable<boolean> {
        const modal: any = this.modals.find(x => x.id === 'modal-dialogJaNein');
        if (modal) {
            return modal.open(message);
        }
        else{
          throw new Error('Confirm-Modal not found!');
        }
    }
}
